import { z } from 'zod';

export const isoDateSchema = z.string().describe('ISO-8601 timestamp');

export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(25),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

/** Page, size and search for the application list endpoints. Without a size you get up to 100 rows. */
export const listQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(100),
  search: z.string().trim().max(191).optional(),
});

export const paginationMetaSchema = z.object({
  page: z.number().int(),
  perPage: z.number().int(),
  total: z.number().int(),
  totalPages: z.number().int(),
});

export function paginated<T extends z.ZodType>(item: T) {
  return z.object({ data: z.array(item), meta: paginationMetaSchema });
}

export type Paginated<T> = { data: T[]; meta: z.infer<typeof paginationMetaSchema> };

export const okSchema = z.object({ ok: z.literal(true) });
